import React, { useEffect, useState } from "react";
import ContenedorPrincipal from "../elementos/basicos/ContenedorPrincipal";
import FormCrearPersona from "../elementos/complejos/FormCrearPersona";
import FormEditarPersona from "../elementos/complejos/FormEditarPersona";
import { fetchDepartamentosData, fetchEstadosData, fetchRolesData, fetchNegociosData } from '../../peticiones_API/PeticionesGestionPersonasPersonas';
import { fetchEmpresasContratantesData } from '../../peticiones_API/PeticionesGestionPersonasEmpresas';

const GestorPersonas = ({ crear, tipo = "empleado" }) => {
  const [loading, setLoading] = useState(true);
  const [departamentos, setDepartamentos] = useState([]);
  const [roles, setRoles] = useState([]);
  /* SE LLAMA `negocios` PORQUE SON NEGOCIOS.
   *
   * Se llamaba `empresas` y lo rellenaba `fetchNegociosData()`. El nombre es lo que hizo que el
   * fallo durara: el selector de «Empresa contratante» lo pintaba con
   * `emp.razon_social || emp.nombre`, y al no traer `razon_social` caia al `|| emp.nombre` **sin
   * chirriar**, ensenando marcas donde debian ir razones sociales.
   *
   * Y guardaba el `negocio_id` en `personas.empresa_contratante_id`, que tiene clave ajena a
   * `empresas`. Con empresas 2..7 y negocios 1,2,3,4,9: elegir «GRUPO LAE» o «GRUPO LAE - Empresas»
   * hacia FALLAR el alta, y elegir cualquiera de las otras tres la guardaba con **una razon social
   * equivocada y sin error**. */
  const [negocios, setNegocios] = useState([]);
  const [empresasContratantes, setEmpresasContratantes] = useState([]);
  const [estados, setEstados] = useState([]);

  useEffect(() => {
      const fetchData = async () => {
        try {
          if (departamentos.length === 0) {
        const departamentosResponse = await fetchDepartamentosData();
        setDepartamentos(departamentosResponse);
          }
          if (roles.length === 0) {
        const rolesResponse = await fetchRolesData();
        setRoles(rolesResponse);
          }
          if (negocios.length === 0) {
            const negociosResponse = await fetchNegociosData();
            setNegocios(negociosResponse);
          }
          if (empresasContratantes.length === 0) {
            setEmpresasContratantes(await fetchEmpresasContratantesData());
          }
          if (estados.length === 0) {
            const estadosResponse = await fetchEstadosData();
            setEstados(estadosResponse);
          }
        } catch (error) {
          console.log("Ha habido un error:", error);
        } finally {
          setLoading(false);
        }
      };
  
      fetchData();
    }, []);

    
  return (
    <>
      <ContenedorPrincipal formaform="true"  >
      {/* SOLO el formulario de CREAR recibe `empresasContratantes`. El de editar carga su propia
          lista y ademas condiciona el campo por rol —ROLES_CON_EMPRESA_CONTRATANTE—, asi que alli
          `GET /api/empresas` alcanza a todos los que pueden verlo. En crear no hay esa condicion y
          el campo es OBLIGATORIO para todos los roles que pueden crear, `general` incluido. */}
      {crear ?
        <FormCrearPersona departamentos={departamentos} roles={roles} negocios={negocios} empresasContratantes={empresasContratantes} tipo={tipo} />
        :
        <FormEditarPersona departamentos={departamentos} roles={roles} negocios={negocios} estados={estados} tipo={tipo} />
      }
      </ContenedorPrincipal>
    </>
  );
}

export default GestorPersonas;